module.exports = __webpack_public_path__ + "static/img/animation.61869629.png";